import React from 'react';
import { Pencil, Trash2, Info } from 'lucide-react';

const WidgetHeader = ({ 
  title, 
  subtitle, 
  status, 
  category, 
  isEditing, 
  isHovering, 
  onEdit, 
  onDelete, 
  onSave, 
  onCancel, 
  tempTitle, 
  setTempTitle,
  showInfoButton, 
  onInfoClick, 
}) => {
  const getCategoryColor = (category) => {
    if (!category) return '';
    const lowerCategory = category.toLowerCase();
    if (lowerCategory === 'immediate attention') return '#ef4444';
    if (lowerCategory === 'call preparation') return '#10b981';
    if (lowerCategory === 'portfolio review' || lowerCategory === 'portfolio analysis') return '#3b82f6';
    return '';
  };

  return (
    <>
      {(category) && (
        <div className="flex items-center gap-2.5 mb-5">
          <div 
            className="w-1.5 h-1.5 rounded-full" 
            style={{ backgroundColor: getCategoryColor(category) }}
          ></div>
          <span 
            className="font-medium text-xs uppercase tracking-wider" 
            style={{ color: getCategoryColor(category) }}
          >
            {category ? category.toUpperCase() : ''}
          </span>
        </div>
      )}
      
      <div className="flex justify-between items-center mb-5">
        <div>
          {isEditing ? (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Widget Title
              </label>
              <input
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                type="text"
                value={tempTitle}
                onChange={e => setTempTitle(e.target.value)}
                placeholder="Enter widget title"
              />
            </div>
          ) : (
            <>
              <div className="flex items-center mb-2">
                <div className="text-lg font-semibold text-primary">
                  {title}
                </div>
                {showInfoButton && (
                  <button
                    onClick={onInfoClick}
                    className="ml-2 text-primary hover:text-primaryDark focus:outline-none transition-colors"
                    title="View SQL Query"
                    type="button"
                  >
                    <Info size={16} />
                  </button>
                )}
                {status && (
                  <span
                    className="mx-3 bg-warning-dark text-white font-bold text-xs py-0.5 px-2.5 rounded-full"
                    style={{
                      backgroundColor: status.toLowerCase() === 'urgent' ? '#ef4444' : 
                                      status.toLowerCase() === 'new' ? '#10b981' : '#3b82f6'
                    }}
                  >
                    {status}
                  </span>
                )}
              </div>
              <div className="text-gray-500 text-sm">
                {subtitle}
              </div>
            </>
          )}
        </div>
        
        {!isEditing && isHovering && (
          <div className="flex gap-2 items-center">
            <button
              className="bg-transparent border-none cursor-pointer rounded flex items-center justify-center transition-colors"
              onClick={onEdit}
              title="Edit"
              type="button"
            >
              <Pencil size={15} className="text-primaryDark" />
            </button>
            <button
              className="bg-transparent border-none cursor-pointer rounded flex items-center justify-center transition-colors"
              onClick={onDelete}
              title="Delete"
              type="button"
            >
              <Trash2 size={15} className="text-red-500" />
            </button>
          </div>
        )}
        
        {isEditing && (
          <div>
            <button
              className="bg-gray-100 px-3 py-1.5 mx-1.5 rounded-md"
              onClick={onSave}
              type="button"
            >
              Save
            </button>
            <button
              className="bg-gray-100 px-3 py-1.5 mx-1.5 rounded-md"
              onClick={onCancel}
              type="button"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default WidgetHeader;